import next from './next-page.svg';
import next_m from './next-page-m.svg';
import next_disable from './next-disable.svg';
import pen_highlight from './pen-highlight.svg';
import pen from './pen.svg';
import prev     from './prev-page.svg';
import prev_m     from './prev-page-m.svg';
import prev_disable from './prev-disable.svg';
import invite        from './invite.svg';
import fullscreen from './fullscreen.svg';
import fullscreen_out from './fullscreen-out.svg';
import live from './live-normal.svg';
import live_hightlight from './live-highlight.svg';
import endplay from './endplay.svg';
import endplay_white from './endplay-white.svg';
import micopen from './microphone-open.svg';
import micclose from './microphone-close.svg';
import audio_open from './audio-open.svg';
import audio_close from './audio-close.svg';
import note from './note.svg';
import view_switch from './view-switch.svg';

export { default as notePage } from '@tencent/docs-design-resources/pc/svg/demomodebar_notepage.svg';

export const NEXT = next;
export const NEXT_M = next_m;
export const NEXT_DISABLE = next_disable;
export const PREV = prev;
export const PREV_M = prev_m;
export const PREV_DISABLE = prev_disable;
export const PEN_HIGHLIGHT = pen_highlight;
export const PEN = pen;
export const INVITE = invite;
export const FULLSCREEN = fullscreen;
export const FULLSCREEN_OUT = fullscreen_out;
export const LIVE = live;
export const LIVE_HIGHLIGHT = live_hightlight;
export const END_PLAY = endplay;
export const END_PLAY_WHITE = endplay_white;

export const MIC_OPEN = micopen;
export const MIC_CLOSE = micclose;
export const AUDIO_OPEN = audio_open;
export const AUDIO_CLOSE = audio_close;
export const NOTE = note;
export const VIEW_SWITCH = view_switch;